module.exports = __webpack_public_path__ + "bg_panflet_male_to_female.59e90ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/bg_panflet_male_to_female.png
// module id = AHu5
// module chunks = 0